/**
 * Resources that open in a panel over the incident tool, so nobody has to leave their place to look
 * something up. Each topic also has a full page (opened from the panel's "Open full page").
 */
export type PanelTopic =
  | "hub" | "lawyer" | "insurance" | "report" | "platforms" | "ir-guidance" | "individuals" | "lost-device" | "law-enforcement"

export const PANEL_TOPICS: Record<PanelTopic, { title: string; fullHref: string }> = {
  hub: { title: "Resources", fullHref: "/directory" },
  lawyer: { title: "Find a breach lawyer", fullHref: "/find-a-lawyer" },
  insurance: { title: "Cyber insurance directory", fullHref: "/insurance" },
  report: { title: "Who to report to", fullHref: "/directory/report" },
  platforms: { title: "Platform incident contacts", fullHref: "/directory/platforms" },
  "ir-guidance": { title: "Choosing an incident-response firm", fullHref: "/directory/ir-guidance" },
  individuals: { title: "For affected individuals", fullHref: "/directory/individuals" },
  "lost-device": { title: "Report a lost or stolen device", fullHref: "/guides/lost-device" },
  "law-enforcement": { title: "How to file a law-enforcement report", fullHref: "/guides/law-enforcement" },
}

const BY_PATH: Record<string, PanelTopic> = Object.fromEntries(
  (Object.entries(PANEL_TOPICS) as [PanelTopic, { fullHref: string }][]).map(([topic, v]) => [v.fullHref, topic]),
)

/** Maps an in-site link (optionally with #anchor) to the panel that shows the same thing, or null. */
export function topicForHref(href: string): { topic: PanelTopic; anchor?: string } | null {
  const [path, anchor] = href.split("#")
  const topic = BY_PATH[path]
  return topic ? { topic, anchor: anchor || undefined } : null
}
